import { defineMessages } from 'react-intl';

export const ratingCardMessages = defineMessages({
  author: {
    id: 'customerRatings.ratingCard.author',
    defaultMessage: 'von {authorNickName} | {created}',
  },
  tagProLabel: {
    id: 'customerRatings.ratingCard.tag.pro.label',
    defaultMessage: 'Vorteile:',
  },
  tagContraLabel: {
    id: 'customerRatings.ratingCard.tag.contra.label',
    defaultMessage: 'Nachteile:',
  },
  responseTitle: {
    id: 'customerRatings.ratingCard.response.title',
    defaultMessage: 'Antwort von BAUR',
  },
  actionsMenuAriaLabel: {
    id: 'customerRatings.ratingCard.actionsMenu.aria.label',
    defaultMessage: 'Optionen zu dieser Bewertung',
  },
  actionsMenuReportText: {
    id: 'customerRatings.ratingCard.actionsMenu.report.text',
    defaultMessage: 'Bewertung melden',
  },
  actionsMenuReportSuccess: {
    id: 'customerRatings.ratingCard.actionsMenu.report.success',
    defaultMessage: 'Vielen Dank für deine Einschätzung.',
  },
  actionsMenuReportError: {
    id: 'customerRatings.ratingCard.actionsMenu.report.error',
    defaultMessage: 'Feedback konnte nicht abgegeben werden.',
  },
});
